import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Course } from '../model/course';
import { deleteCourse, getCourses, putCourse } from '../api/courses';
import { setErrorMessage } from './errorSlice';

interface CourseState {
  courses: Course[]
  currentCourse: Course | null
}

const initialState: CourseState = {
  courses: [],
  currentCourse: null 
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    addCourse: (state, action: PayloadAction<Course>) => {
      state.courses.push(action.payload);
      state.currentCourse = action.payload;
    },
    setCurrentCourse: (state, action: PayloadAction<Course>) => {
      state.currentCourse = action.payload;
    },
    updateCourse: (state, action: PayloadAction<Course>) => {
        state.courses.forEach((course, index) => {
            if (course.uuid == action.payload.uuid) {
                state.courses[index] = action.payload
            }
        })

        if (state.currentCourse?.uuid == action.payload.uuid) {
          state.currentCourse = action.payload
        }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCoursesAsync.fulfilled, (state: CourseState, action: PayloadAction<Course[]>) => {
        state.courses = action.payload;
      })
      .addCase(getCoursesAsync.rejected, (state: CourseState, action) => {
        setErrorMessage(action.error);
      })
      .addCase(addCourseAsync.fulfilled, (state: CourseState, action: PayloadAction<Course>) => {
        state.courses.push(action.payload);
        state.currentCourse = action.payload;
      })
      .addCase(addCourseAsync.rejected, (state: CourseState, action) => {
        setErrorMessage(action.error);
      })
      .addCase(deleteCourseAsync.fulfilled, (state: CourseState, action: PayloadAction<boolean>) => {
        state.courses = state.courses.filter(course => course.uuid !== state?.currentCourse?.uuid);

        let programCourses = state.courses.filter(course => course.programId === state.currentCourse?.programId)
        state.currentCourse = programCourses.length > 0 ? programCourses[0] : null;
      })
      .addCase(deleteCourseAsync.rejected, (state: CourseState, action) => {
        console.error(action.error.message);
      });
  },
});

export const getCoursesAsync = createAsyncThunk('program/getCoursesAsync', async ({ accessToken }: { accessToken: string}) => {
    const response = await getCourses(accessToken);
    return response;
  }
);

export const addCourseAsync = createAsyncThunk('course/addCourseAsync', async ({ accessToken, course  }: { accessToken: string; course: Course}) => {
    const response = await putCourse(accessToken, course.uuid, course);
    return response;
  }
);

export const deleteCourseAsync = createAsyncThunk('course/deleteCourseAsync', async ({ accessToken, course }: { accessToken: string, course: Course}) => {
    const response = await deleteCourse(accessToken, course.uuid);
    return response;
  }
);


export const { setCurrentCourse, addCourse, updateCourse} = courseSlice.actions;
export default courseSlice.reducer;